// Tiny replacement for @fortawesome/react-fontawesome: draws a Font Awesome icon definition
// (from @fortawesome/free-*-svg-icons) as an inline <svg>. Same markup and class names as the
// official component, so styling (index.css) and the RTL arrow flip keep working, without the
// ~60 KB Font Awesome runtime. Supports the options this site uses: `spin` and `size="2x"`.
export function FontAwesomeIcon({ icon, className = '', spin = false, size, title, ...rest }) {
  if (!icon?.icon) return null;
  const [width, height, , , path] = icon.icon;
  const paths = Array.isArray(path) ? path : [path];
  const cls = ['svg-inline--fa', `fa-${icon.iconName}`, spin && 'fa-spin', size && `fa-${size}`, className].filter(Boolean).join(' ');
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox={`0 0 ${width} ${height}`} className={cls} focusable="false"
      data-prefix={icon.prefix} data-icon={icon.iconName} {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': 'true' })} {...rest}>
      {title && <title>{title}</title>}
      {paths.map((d, i) => <path key={i} fill="currentColor" d={d} />)}
    </svg>
  );
}
